import { combineReducers } from 'redux'

import completionsReducer from './features/completions/slice'
import filesReducer from './features/files/slice'

const rootReducer = combineReducers({
  completions: completionsReducer,
  files: filesReducer,
})

export default rootReducer
